import * as React from "react";
type Props = {
  className?: string,
};
function SvgVegetarian({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Vegetarian"
      className={className}
    >
      <path
        d="M14.6715 34.1118V37.4839H25.2086V34.1118M36.8943 8.18248L4.38791 8.59106M24.9579 8.20391C14.0779 -3.29037 3.92862 8.6732 3.92862 8.6732C15.3679 19.6046 24.9579 8.20391 24.9579 8.20391ZM38.1058 20.3375C38.1058 28.3082 29.9751 34.7703 19.9458 34.7703C9.91648 34.7703 1.78577 28.3082 1.78577 20.3375H38.1058Z"
        stroke="currentColor"
      />
    </svg>
  );
}
export default SvgVegetarian;
